import { mapActions, mapGetters, mapState } from 'vuex';
import infiniteLoading from 'vue-infinite-loading';
import stickyConstants from '@/helpers/stickyConstants';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import marketFiltersDesktopGridWatchlist from '@/components/market/market-filters/market-filters-desktop-grid-watchlist/market-filters-desktop-grid-watchlist.vue';
import marketFiltersMobileWatchlist from '@/components/market/market-filters/market-filters-mobile-watchlist/market-filters-mobile-watchlist.vue';
import seoMetaMixin from '@/mixins/seoMeta';


const NO_ITEMS_MESSAGE = 'There are no markets in your Watchlist';
const NO_MORE_ITEMS_MESSAGE = 'No more markets to display';
const SCROLL_FOR_MORE = 'Scroll down for more markets';

export default {
  mixins: [
    loaderMixin,
    contentLoaderMixin,
    seoMetaMixin,
  ],
  props: {
    theme: {
      type: String,
      default: '',
    },
  },
  components: {
    marketFiltersDesktopGrid: marketFiltersDesktopGridWatchlist,
    marketFiltersMobile: marketFiltersMobileWatchlist,
    marketListItem: marketListItemV2,
    infiniteLoading,
  },
  metaInfo() {
    return this.buildSeoMeta({
      title: 'Watchlist',
    });
  },
  data() {
    return {
      loadedInfo: SCROLL_FOR_MORE,
      infiniteLoader: null,
      stickyOptions: stickyConstants.mobile,
      watchersDisabled: false,
      watchersRemoved: 0,
    };
  },
  computed: {
    ...mapState('watchlist', [
      'selectedOrder',
      'selectedTimespan',
    ]),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapState('watchlist', ['watchlist']),
    items() {
      return this.watchlist.data === null ? [] : this.watchlist.data;
    },
    showNoMarketsMessage() {
      return !this.isLoading && this.items.length === 0;
    },
    filtering() {
      return this.selectedOrder.name + this.selectedTimespan.name;
    },
    infiniteLoadingKey() {
      return `watchlist-${this.selectedOrder.sort}-${this.selectedTimespan.parameter}-${this.watchersRemoved}`;
    },
  },
  watch: {
    filtering: 'filteringChanged',
    items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.watchlist.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }

      if (!this.watchlist.canLoadMore) {
        this.loadedInfo = this.items.length > 0 ? NO_MORE_ITEMS_MESSAGE : NO_ITEMS_MESSAGE;
      }
    },
  },
  methods: {
    ...mapActions('browse', ['clearOrder', 'clearTimespan']),
    ...mapActions('watchlist', ['resetWatchlist', 'getWatchList', 'reloadWatchlist']),
    ...mapActions('profile', [
      'removeMarketFromWatchList',
    ]),
    filteringChanged() {
      if (this.watchersDisabled) return;

      this.$router.push({
        name: 'market-watchlist',
        query: {
          sort: this.selectedOrder.sort,
          sortParameter: this.selectedTimespan.parameter,
        },
      });
      this.resetWatchlist();
    },
    onRemoveMarketFromWatchList(item) {
      this.reloadWatchlist();
    },
    goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.watchlist.canLoadMore) {
        this.isLoading = true;
        this.getWatchList()
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
  },
  mounted() {
    this.resetWatchlist();
  },
  beforeRouteLeave(to, from, next) {
    // browse.selectedOrder etc i shared by watchlist and markets page
    this.watchersDisabled = true;
    this.clearTimespan()
      .then(this.clearOrder())
      .then(() => next());
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-watchlist/page-watchlist.js